import fetcher from './axiosService'
import { AxiosRequestConfig } from 'axios'
import { isAuthenticated } from 'auth/authService'

const fetcherInstance = fetcher()
const FetcherClient = async (
  url: string,
  options?: AxiosRequestConfig,
): Promise<any> => {
  const authToken = await isAuthenticated()
  fetcherInstance.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${authToken}`

  const response = await fetcherInstance(url, options).then(
    (response) => response,
  )
  return response
}

export { fetcher, FetcherClient }
